export enum ImportSupplierStatus {
    NoInterval = 'STATUS_NO_INTERVAL',
    OnSchedule = 'STATUS_ON_SCHEDULE',
    Overdue = 'STATUS_OVERDUE',
}

const translationObject: { [Key in ImportSupplierStatus]: string } = {
    [ImportSupplierStatus.NoInterval]: 'app.importSupplierStatus.noInterval',
    [ImportSupplierStatus.OnSchedule]: 'app.importSupplierStatus.onSchedule',
    [ImportSupplierStatus.Overdue]: 'app.importSupplierStatus.overdue',
};

export const getImportSupplierStatusTranslationId = (status?: ImportSupplierStatus): string => {
    return status ? translationObject[status] : 'app.importSupplierStatus.noInterval';
};
